import { autorun, makeAutoObservable } from "mobx";
import { AttributeShelf } from "../AttributeShelf";
import { InputShelf } from "../InputShelf";
import type { apiTypes } from "../../services";
import { MIN_VALUE_ANTICIPATION } from "../../constants";
import { StoreNameEnum } from "../../enum/storesEnum";
import type { AnticipationStoreState } from "../../stores/AnticipationStore/interfaces";
import CryptoJS from "crypto-js";
import { env } from "../../config";

const MIN_VALUE_TO_FGTS_ANTICIPATION = MIN_VALUE_ANTICIPATION;

export class PartialAnticipationShelf {
	public maxFGTSValueAvailable = new AttributeShelf(0);
	public yearsOfAnticipation = new AttributeShelf(0);
	public selectedFGTSAnticipationValue = new AttributeShelf("");
	public hasSelectedFGTSAnticipationValue = new AttributeShelf(false);
	public partialInput = new InputShelf(0);
	public partialSimulationData = new AttributeShelf<apiTypes.PartialAnticipationResponse | null>(null);
	public minFGTSValueAvailable = new AttributeShelf(MIN_VALUE_TO_FGTS_ANTICIPATION);

	constructor() {
		makeAutoObservable(this);

		// Carrega o estado salvo do localStorage
		this.loadState();

		// Monitora mudanças e salva o estado automaticamente
		autorun(() => {
			this.saveState();
		});
	}

	public setMaxFGTSValueAvailable(value: number, years: number): void {
		if (years === 10) {
			return this.maxFGTSValueAvailable.set(value);
		}
		return;
	}

	// Limpa o estado
	public clearState(): void {
		sessionStorage.removeItem(StoreNameEnum.PARTIAL_ANTICIPATION);
	}

	// Reinicializa o estado da PartialAnticipation
	public resetState(): void {
		this.resetStatePartialAnticipation();
	}

	private resetStatePartialAnticipation(): void {
		this.maxFGTSValueAvailable.set(0);
		this.yearsOfAnticipation.set(0);
		this.selectedFGTSAnticipationValue.set("");
		this.hasSelectedFGTSAnticipationValue.set(false);
		this.partialInput.onChange(0);
		this.partialSimulationData.set(null);
		this.minFGTSValueAvailable.set(MIN_VALUE_TO_FGTS_ANTICIPATION);
	}

	// Salva o estado atual no sessionStorage
	private saveState(): void {
		const state = {
			maxFGTSValueAvailable: this.maxFGTSValueAvailable.value,
		};
		const cipherInfo: string = CryptoJS.AES.encrypt(JSON.stringify(state), env.cryptoKey).toString();
		sessionStorage.setItem(StoreNameEnum.PARTIAL_ANTICIPATION, cipherInfo);
	}

	// Carrega o estado salvo do sessionStorage
	private loadState(): void {
		const savedState = sessionStorage.getItem(StoreNameEnum.PARTIAL_ANTICIPATION);
		if (savedState) {
			const bytes = CryptoJS.AES.decrypt(savedState, env.cryptoKey);
			const decryptedData: string = bytes.toString(CryptoJS.enc.Utf8);
			const state: AnticipationStoreState = JSON.parse(decryptedData);
			this.maxFGTSValueAvailable.set(state.maxFGTSValueAvailable);
		}
	}
}
